<template>
  <v-container class="mt-16">
    <v-text-field solo v-model="estaGuia" @input="cortadorDeGuias(estaGuia)"></v-text-field>
    <div class="mb-2">
      <v-btn color="green" style="width:50%;" @click="copiarDatos()" dark x-large>COPIAR</v-btn>
      <v-btn color="red" style="width:50%;" @click="limpiar()" dark x-large>LIMPIAR</v-btn>
    </div>
    <v-textarea
      id="textAreaDatosACopiar"
      rows="1"
      auto-grow
      solo
      v-model="guiasFormateadas"
    ></v-textarea>
  </v-container>
</template>

<script>
import _ from "lodash";
export default {
  data: () => ({
    guiasFormateadas: "",
    estaGuia: ""
  }),
  methods: {
    copiarDatos: _.debounce(async function(index) {
      let testingCodeToCopy = document.querySelector("#textAreaDatosACopiar");
      testingCodeToCopy.setAttribute("type", "text"); // 不是 hidden 才能複製
      testingCodeToCopy.select();
      var successful = document.execCommand("copy");
    }, 100),
    cortadorDeGuias: _.debounce(async function(guiaRastreo) {
      if (guiaRastreo.length >= 16) {
        if (guiaRastreo.length == 34) {
          guiaRastreo = guiaRastreo.substring(guiaRastreo.length - 12, guiaRastreo.length);
        } else if (guiaRastreo.length == 16) {
          guiaRastreo = guiaRastreo.substring(0, guiaRastreo.length - 4);
        }
        this.guiasFormateadas += guiaRastreo + "\n";
        this.estaGuia = "";
      }

      //   console.log(guiaRastreo);
    }, 200),
    limpiar() {
      this.guiasFormateadas = "";
      this.estaGuia = "";
    }
  }
};
</script>
